module.exports = __webpack_public_path__ + "static/media/Right pawn bottom.5c56431e.svg";